import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MdsIconsModule } from '@mds/icons';
import { AppHeader } from '../utils/interfaces/app-header';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { AppItem } from '@mds/common';
import { ListSearchCheckboxComponent } from '@components/dialogs/list-search-checkbox/list-search-checkbox.component';

@Component({
  selector: "app-header-container",
  standalone: true,
  templateUrl: "./header-container.component.html",
  styleUrls: ["./header-container.component.scss"],
  imports: [
    CommonModule,
    MdsIconsModule,
    MatMenuModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ListSearchCheckboxComponent,
  ],
})
export class HeaderContainerComponent {
  @Input() appDetails: AppHeader;

  @Input() extraData: { list: AppItem[]; selectedList: AppItem[] };

  @Output() updateFavorite = new EventEmitter<any>();

  handleFavoriteUpdate(data:any){
    this.updateFavorite.emit(data);
  }
}
